/* Station B — Custom JS */
document.addEventListener('DOMContentLoaded', function () {
  // Accordion toggle
  document.querySelectorAll('.sb-accordion-header').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.sb-accordion-item');
      var body = item.querySelector('.sb-accordion-body');
      var isActive = item.classList.contains('active');

      // Close all
      document.querySelectorAll('.sb-accordion-item.active').forEach(function (open) {
        open.classList.remove('active');
        open.querySelector('.sb-accordion-body').style.maxHeight = null;
      });

      if (!isActive) {
        item.classList.add('active');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });
});
